export const transaksiJurnalFormData = (
  dropdownAkunDebet,
  dropdownAkunKredit
  // dropdownUnitUsaha
) => {
  const tanggalSaatIni = new Date().toISOString().slice(0, 10);

  return [
    {
      id: "tanggal_transaksi",
      label: "Tanggal Transaksi",
      fields: [
        {
          type: "date",
          defaultDate: true,
          defaultDateValue: tanggalSaatIni,
        },
      ],
    },
    {
      id: "kode_akun_debet",
      label: "Pilih Akun Debet",
      fields: [
        {
          type: "option",
          options: dropdownAkunDebet,
        },
      ],
    },
    {
      id: "kode_akun_kredit",
      label: "Pilih Akun Kredit",
      fields: [
        {
          type: "option",
          options: dropdownAkunKredit,
        },
      ],
    },
    // {
    //   id: "id_unit_usaha",
    //   label: "Pilih Unit Usaha",
    //   fields: [
    //     {
    //       type: "option",
    //       options: dropdownUnitUsaha,
    //     },
    //   ],
    // },
    {
      id: "jumlah_transaksi_jurnal",
      label: "Jumlah Transaksi",
      fields: [
        {
          type: "input",
          placeholder: "Masukan Jumlah Transaksi",
        },
      ],
    },
    {
      id: "keterangan_transaksi_jurnal",
      label: "Keterangan Transaksi",
      fields: [
        {
          type: "input",
          placeholder: "Masukan Keterangan Transaksi",
        },
      ],
    },
  ];
};
